import React from "react";
import {
  Dialog,
  Typography,
  DialogContentText,
  Slide,
  IconButton,
  TextField,
  FormLabel,
  FormControl,
  List,
  ListItem,
  Divider,
  ListItemButton,
  ListItemIcon,
  Box,
} from "@mui/material";
import Inventory2Rounded from '@mui/icons-material/Inventory2Rounded';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from "@mui/material/transitions";
import { Pedido } from "../pages/Historico/Historico.tsx";

interface OrderDetailsAlertProps {
  open: boolean;
  onClose: () => void;
  pedido: Pedido;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OrderInvoicedDetailsAlert = ({ open, onClose, pedido }: OrderDetailsAlertProps) => {
  const formatarData = (data: string) => {
    const dataHora = new Date(`${data}`);
    return dataHora.toLocaleString("pt-BR", {
      dateStyle: "short",
    });
  };

  const calcularTotalPedido = () => {
    return pedido.itens.reduce((total, item) => total + item.itenS_QUANTIDADE * item.itenS_PRECO_BRUTO, 0);
  };
  

  return (
    <Dialog
      open={open}
      scroll="paper"
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      maxWidth="sm"
    >
      {/* Header */}
      <Box display="flex" paddingTop={3} paddingLeft={3} paddingRight={3}>
        <Box display="flex" flexDirection="column" flex={1}>
          <Box display="flex" justifyContent="space-between" alignItems="start">
            
            <Box>
              <Typography variant="h4" fontWeight="bold">
                Pedido {formatarData(pedido.capa.notA_DT_EMISSAO)}
              </Typography>
              <Typography variant="body2" color="#9e9e9e" mt={2}>
                {formatarData(pedido.capa.notA_DT_EMISSAO)} | Nota Nº : {pedido.capa.notA_NUMERO} | Serie : {pedido.capa.notA_SERIE}
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between" alignItems="start">
              <Box sx={{ bgcolor: "#6fbf73", color: "#fff", px: 1.5,py: 0.5, fontSize: 12, fontWeight: "bold",width: "fit-content",}}>
                Status: Faturado
              </Box>

              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{ color: '#fff', ml: 1, mt: -1}}
              >
                <CloseIcon />
              </IconButton>
            </Box>

          </Box>

          <Box mt={1.5} display="flex" justifyContent="space-between" alignItems="center">
            <FormControl>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <FormLabel htmlFor="observacao">Observação do pedido:</FormLabel>
              </Box>
              <TextField 
                disabled
                inputProps={{ maxLength: 50 }} 
                multiline 
                rows={2}
                sx={{width: 280}}
                placeholder="nenhuma observação."
                value={pedido.capa.NOTA_LIV_OBS} 
              />
            </FormControl>

            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{ ml: 2, whiteSpace: 'nowrap', alignSelf: 'flex-end' }}
            >
              Total: R$ {calcularTotalPedido().toFixed(2)}
            </Typography>
          </Box>
        </Box>
        
      </Box>

      {/* Body */}
        <DialogContentText id="alert-dialog-slide-description" component="div">
          <List>
            {pedido.itens.map((item, i) => (
                <React.Fragment key={i}>
                  <Divider />
                  <ListItem>
                    <ListItemButton
                      component="a"
                      sx={{
                        borderRadius: 2,
                        '&:hover': { backgroundColor: 'action.hover', transform: 'scale(1.01)' },
                        transition: 'transform 0.2s ease',
                      }}
                    >
                      <ListItemIcon>
                        <Inventory2Rounded color="primary" fontSize="large" />
                      </ListItemIcon>
                      <Box flexGrow={1} sx={{ marginLeft: 2 }}>
                        <Typography variant="subtitle1" fontWeight="bold" color="textPrimary">
                          {item.proD_REF_FORN} - {item.proD_DESCRICAO}
                        </Typography>
                        <Typography variant="body1" color="text.secondary" fontWeight="bold">
                          R$ {item.itenS_PRECO_BRUTO.toFixed(2)} x {item.itenS_QUANTIDADE}
                        </Typography>
                        <Typography variant="body1" color="success.main" fontWeight="bold">
                          Total: R$ {(item.itenS_PRECO_BRUTO * item.itenS_QUANTIDADE).toFixed(2)}
                        </Typography>
                      </Box>
                    </ListItemButton>
                  </ListItem>
                </React.Fragment>
              ))}
          </List>
        </DialogContentText>

    </Dialog>
  );
};

export default OrderInvoicedDetailsAlert;
